import {
  createContext,
  useCallback,
  useState,
  useContext,
  ReactNode,
} from 'react';

interface ClipBoardManualContextProps {
  textCliped: string;
  setClipBoard(textCliped: string): void;
}

const ClipBoardManualContext = createContext<ClipBoardManualContextProps>(
  {} as ClipBoardManualContextProps,
);

interface ClipBoardManualProviderProps {
  children: ReactNode;
}

function ClipBoardManualProvider({ children }: ClipBoardManualProviderProps) {
  const [textCliped, setTextCliped] = useState('');

  const setClipBoard = useCallback((text: string) => {
    setTextCliped(text);
  }, []);

  return (
    <ClipBoardManualContext.Provider value={{ setClipBoard, textCliped }}>
      {children}
    </ClipBoardManualContext.Provider>
  );
}

function useAppClipBoardManual(): ClipBoardManualContextProps {
  const context = useContext(ClipBoardManualContext);

  if (!context) {
    throw new Error(
      'useAppClipBoardManual must be used within an ClipBoardManualProvider',
    );
  }

  return context;
}

export { ClipBoardManualProvider, useAppClipBoardManual };
